import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import SignInPage from '../../components/auth/sign-in';
import AuthLayout from '../../components/layout/AuthLayout';
import SEO from '../../components/seo';
import { setConfigData } from '../../redux/slices/configData';
import useConfigData from '../../hooks/useConfigData';

const SignIn = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { configData } = useSelector((state) => state.configData);
    const { configData: fetchedConfigData } = useConfigData();

    useEffect(() => {
        if (fetchedConfigData && !configData) {
            dispatch(setConfigData(fetchedConfigData));
        }
    }, [fetchedConfigData, configData, dispatch]);

  return (
    <>
      <SEO
        title={configData ? `Sign In - ${configData?.business_name}` : "Sign In"}
        description="Sign in to your account"
        image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
        businessName={configData?.business_name}
      />
      <AuthLayout>
        <SignInPage configData={configData} />
      </AuthLayout>
    </>
  );
};

export default SignIn;